export default __webpack_public_path__ + "static/media/pen-bg.348fd87c.jpg";